/* ---------------------------------------------------------------------------
   UF VARIANT ACCENT

   Repaints --product-accent when the customer changes variant.

   Every section sets --product-accent as an inline style on its own root, so
   there is no single element to update and no stylesheet rule that could win
   against them — an inline custom property beats any selector short of
   !important. Walking the elements that declare it is both simpler and safer
   than trying to out-specify them, and it picks up sections added later
   without this file knowing they exist.

   No transition. The repaint follows a deliberate tap, so it should land at
   the same moment as the rest of the variant change — the price, the image and
   the stock line all update instantly, and a colour easing in behind them
   reads as lag rather than polish.
--------------------------------------------------------------------------- */

(function () {
  'use strict';

  if (window.__ufAccentBound) return;
  window.__ufAccentBound = true;

  var node = document.querySelector('[data-uf-accent-map]');
  if (!node) return;

  var map;
  try {
    map = JSON.parse(node.textContent || '{}');
  } catch (e) {
    return;
  }
  if (!map || !Object.keys(map).length) return;

  /* Captured once, on the way in. A variant with no rule of its own has to be
     able to go BACK to the product's colour, and by the time it is selected
     the previous variant's colour is already painted over it. */
  var original = null;

  /* TWO WAYS A SECTION GETS ITS ACCENT, and both have to be reached.

     With a product accent metafield set, each section writes the colour as an
     inline style on its own root. WITHOUT one — which is the case for a product
     whose colour only exists per variant — the section writes no style at all
     and falls back to the default declared on its own class in CSS. That
     default sits on the section root, so setting the variable further up the
     tree does nothing: the local declaration wins over anything inherited.

     So the section roots themselves are the targets, whether or not they are
     currently carrying an inline value. */
  function targets() {
    var seen = [];
    var add = function (el) {
      if (el && seen.indexOf(el) === -1) seen.push(el);
    };

    document
      .querySelectorAll('[style*="--product-accent"]')
      .forEach(add);

    /* The first classed child of each Shopify section wrapper is the root that
       carries .uf-stack, .uf-stats and friends — and therefore the default. */
    document
      .querySelectorAll('[id^="shopify-section"] > [class]')
      .forEach(add);

    return seen;
  }

  function apply(variantId) {
    var list = targets();
    if (!list.length) return;

    if (original === null) {
      original = list[0].style.getPropertyValue('--product-accent').trim();
    }

    var colour = map[String(variantId)] || original;

    list.forEach(function (el) {
      /* An empty original means the product had no accent of its own, so the
         way back is to remove the property and let each section's own CSS
         default reappear — not to paint an empty string over it. */
      if (colour) {
        el.style.setProperty('--product-accent', colour);
      } else {
        el.style.removeProperty('--product-accent');
      }
    });

    if (!colour) {
      document.documentElement.style.removeProperty('--product-accent');
      return;
    }

    /* Anything reading the variable off the root rather than off a section. */
    document.documentElement.style.setProperty('--product-accent', colour);
  }

  function selected() {
    var input = document.querySelector('[data-uf-flavour]:checked');
    return input && input.dataset ? input.dataset.variantId : null;
  }

  var initial = selected();
  if (initial) apply(initial);

  /* Delegated, because the buy box re-renders parts of itself on variant change
     and a listener bound directly to an input does not survive that. */
  document.addEventListener('change', function (event) {
    var t = event.target;
    if (!t || !t.matches || !t.matches('[data-uf-flavour]')) return;
    if (!t.checked) return;
    apply(t.dataset.variantId);
  });
})();
